import produce from "immer";
import { CustomizationState } from "../";
import { SelectionPhoto } from "../../../types/selection/selection";

export interface RemovePictureFromContentAction {
  pageKey?: string;
  selectionPhoto: SelectionPhoto;
  type: "removePictureFromContent";
}

export function removePictureFromContent(
  state: CustomizationState,
  action: RemovePictureFromContentAction
): CustomizationState {
  return produce(state, (draftState) => {
    const { selectionPhoto, pageKey } = action;

    draftState.content.pages = draftState.content.pages.map((page) => {
      if (pageKey && page.key !== pageKey) {
        return page;
      }

      page.editablePictures = page.editablePictures.filter(
        (editablePicture) =>
          !(
            editablePicture.selectionPhotoKey === selectionPhoto.key ||
            editablePicture.selectionPhotoKey ===
              `${selectionPhoto.provider}-${selectionPhoto.providerRef}`
          )
      );
      return page;
    });
  });
}
